import React, { useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../css/StylistStyle.css';
import { getClientNotificationList } from '../../../Service';
import { useDispatch, useSelector } from 'react-redux';
import { setStylistNotification } from "../../../reducers/User/action";
import * as signalR from "@microsoft/signalr";
import { showNotification, requestNotificationPermission } from '../../Reusable';
import { initClientConnection } from '../../Reusable/signalRService';
import moment from 'moment';
 
export default function AdminHeader () {

    const dispatch = useDispatch();
    const loggedUser = useSelector(store => store.user.stylistuser);
    let webNotificationStatus = useSelector(store => store.user.webNotificationStatus);
    
    const connectionRef = useRef(null);
    // useEffect(() => {
    //     getClientNotificationList().then(res => notificationResponseHandle(res));
    // }, []);

    // const notificationResponseHandle = ( res ) => {

    //     if ( res.data.statusCode === 200 ) {
    //         let notification = {'count' : res.data.isClientViewedCount, 'list' : res.data.bookingList};

    //         dispatch(setStylistNotification(notification));
    //     } 
    // }

    // useEffect(() => {
    //     let userId = 'ClientNotification'+loggedUser.clientId;
    //     const connection = new signalR.HubConnectionBuilder()
    //         .withUrl("https://unextdev.datanetiix.com/notificationHub")
    //         .withAutomaticReconnect()
    //         .build();
    
    //     connection
    //         .start()
    //         .then()
    //         .catch((err) => console.error("Error connecting to SignalR:", err));
    
    //     connection.on(userId, (item) => {
    //         console.log('pro irem', item);
    //         let notification = {'count' : item.isClientViewedCount, 'list' : item.bookingList};
    //         dispatch(setStylistNotification(notification));
    //     });
    
    //     connectionRef.current = connection; // Store connection in ref
    
    //     return () => {
    //         connection.stop();
    //     };
    // }, []);

    // useEffect(() => {
    //     requestNotificationPermission(dispatch, webNotificationStatus);
    //     let userId = 'ClientPushNotification'+loggedUser.clientId;
    //     const connection = new signalR.HubConnectionBuilder()
    //         .withUrl("https://unextdev.datanetiix.com/clientPushNotificationHub")
    //         .withAutomaticReconnect()
    //         .build();
    
    //     connection
    //         .start()
    //         .then()
    //         .catch((err) => console.error("Error connecting to SignalR:", err));
    
    //     connection.on(userId, (item) => {
    //         console.log('item', item);
    //         if ( item.length > 0 ) {
    //             console.log('list', item[0].bookingList[0]);
                
    //             const notificationTitle = item[0].bookingList[0].serviceName;
    //             const notificationBody = `${item[0].bookingList[0].notificationType} on ${moment(item[0].bookingList[0].slotDateTime).format("MM-DD-YYYY HH:mm")}`;
                
    //             showNotification(notificationTitle, { body: notificationBody });
    //         }
    //     });
    
    //     connectionRef.current = connection; // Store connection in ref
    
    //     return () => {
    //         connection.stop();
    //     };
    // }, []);

    // useEffect(() => {
    //     if (loggedUser?.clientId) {
    //         requestNotificationPermission(dispatch, webNotificationStatus);

    //         const userId = "ClientPushNotification" + loggedUser.clientId;

    //         initClientConnection(userId, (item) => {
    //             if (item.length > 0) {
    //                 const booking = item[0].bookingList[0];
    //                 const title = booking.serviceName;
    //                 const body = `${booking.notificationType} on ${moment(booking.slotDateTime).format("MM-DD-YYYY HH:mm")}`;

    //                 showNotification(title, { body });
    //             }
    //         });
    //     }
    // }, [loggedUser?.clientId]);

    return(
        <section className='top-nav'>
            <div className='container'>
                <div className='row'> 
                    <div className='col-12 col-md-12'>
                        
                    </div>
                </div> 
            </div>
        </section>
    )

}